export default __webpack_public_path__ + "static/bovingdons_team-62681f9bc25c55ebe8a367614f77c440.jpg";